module.exports = __webpack_public_path__ + "media/promo/promo/images/chief-glow-3-5a1b02fbcd7550b6f5752a9559595299.png";